import setup from './setup';
setup();    //# sourceMappingURL=install.js.map
